import React from 'react';

export default function CalendarIcon() {
    return (
        <svg viewBox="0 0 16 16">
            <path d="M13.86,4a.14.14,0,0,1,.14.14v9.72a.14.14,0,0,1-.14.14H2.14A.14.14,0,0,1,2,13.86V4.14A.14.14,0,0,1,2.14,4H13.86m0-2H2.14A2.14,2.14,0,0,0,0,4.14v9.72A2.14,2.14,0,0,0,2.14,16H13.86A2.14,2.14,0,0,0,16,13.86V4.14A2.14,2.14,0,0,0,13.86,2Z" /><rect x="4" width="2" height="2" /><rect x="4" y="10" width="2" height="2" /><rect x="7" y="10" width="2" height="2" /><rect x="10" y="10" width="2" height="2" /><rect x="10" width="2" height="2" /><rect x="4" y="6" width="2" height="2" /><rect x="7" y="6" width="2" height="2" /><rect x="10" y="6" width="2" height="2" />
        </svg>
    )
}
